import { Component } from '@angular/core'

@Component({
  selector: 'se-po-remove-persona-modal-docs',
  templateUrl: './remove-persona-modal-docs.component.html',
  styleUrls: ['./remove-persona-modal-docs.component.scss'],
  standalone: false,
})
export class RemovePersonaModalDocsComponent {
}
